import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Recommend from "./components/Recommend";
import Catalog from "./components/Catalog";
import Movies from "./components/Movies";
import RegionSplit from "./components/RegionSplit";
import BingeGuide from "./components/BingeGuide";
import Glossary from "./components/Glossary";
import Ranking from "./components/Ranking";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body">
      <Navbar />
      <main className="w-full">
        <Hero />
        <Recommend />
        <Catalog />
        <Movies />
        <RegionSplit />
        <BingeGuide />
        <Glossary />
        <Ranking />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}